export const config = [
  {
    icon: "/landing_page_assets/icons/Phone.svg",
    titles: ["Phone", "(833) 518-1613"],
    description: "Our office hours are 9 AM - 6 PM ET, Monday - Friday",
  },
  {
    icon: "/landing_page_assets/icons/Fax.svg",
    titles: ["Fax", "(833) 694-1477"],
    description: "You can send a fax order to us using this",
    descriptionAccent: "order form.",
  },
  {
    icon: "/landing_page_assets/icons/Email.svg",
    titles: ["Email", "support@versemedical.com"],
  },
];
